import { Skeleton } from '@/components/ui/skeleton';

export const AdminSkeleton = () => {
  return (
    <div className='p-4 w-full mx-auto'>
      <div className='animate-pulse flex space-x-4'>
        <div className='flex-1 space-y-6 py-1'>
          <div className='grid grid-cols-3 gap-4'>
            <Skeleton className='h-8 rounded col-span-2' />
            <Skeleton className='h-8 rounded col-span-1' />
          </div>
          <div className='flex flex-col gap-3'>
            <Skeleton className='h-16 rounded' />
            <Skeleton className='h-16 rounded' />
          </div>
        </div>
      </div>
    </div>
  );
};
